"use strict";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const TabPanel = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx("div", { ref, ...props, role: "tabpanel", tabIndex: -1 })
);
TabPanel.displayName = "TabPanel";
export {
  TabPanel
};
